<h2 class="title">Settings</h2>

<div class="card">
  <h3 class="title">Sort order</h3>

  <div class="form-group">
    <input id="alphabetical" name="sortOrder" type="radio" [value]="todoSortOrder.Alphabetical"
           [(ngModel)]="todoService.settings.sortOrder"
           (change)="onSettingsChange()">
    <label for="alphabetical">Alphabetical</label>
  </div>

  <div class="form-group">
    <input id="newestFirst" name="sortOrder" type="radio" [value]="todoSortOrder.NewestFirst"
           [(ngModel)]="todoService.settings.sortOrder"
           (change)="onSettingsChange()">
    <label for="newestFirst">Newest first</label>
  </div>

  <div class="form-group">
    <input id="oldestFirst" name="sortOrder" type="radio" [value]="todoSortOrder.OldestFirst"
           [(ngModel)]="todoService.settings.sortOrder"
           (change)="onSettingsChange()">
    <label for="oldestFirst">Oldest first</label>
  </div>
</div>


<div class="card">
  <h3 class="title">Completed tasks</h3>

  <div class="form-group">
    <input id="hideCompleted" type="checkbox" value="hideCompleted"
           [(ngModel)]="todoService.settings.hideCompleted"
           (change)="onSettingsChange()">
    <label for="hideCompleted">Hide completed tasks</label>
  </div>

  <div class="form-group">
    <input id="incompleteFirst" type="checkbox" value="incompleteFirst"
           [(ngModel)]="todoService.settings.incompleteFirst"
           [disabled]="todoService.settings.hideCompleted"
           (change)="onSettingsChange()">
    <label for="incompleteFirst">Move completed tasks to the bottom</label>
  </div>
</div>
